import http from '@/utils/http'

const {get, post, postFormData, uploadFile, baseUrl} = http;

// 获取banner图
export function getBannerPicListApi(banner_type) {
	return postFormData(baseUrl + "/web_api/getbannerpiclist", { banner_type })
}

// 新闻资讯列表
export function getNewsListApi(data) {
	return postFormData(baseUrl + "/web_api/getnewslist", data)
}

// 获取新闻详情
export function getNewsInfoApi(news_id) {
	return postFormData(baseUrl + "/web_api/getnewsinfo", { news_id })
}

// 获取关于我们
export function getAboutUsInfoApi(data) {
	return postFormData(baseUrl + "/web_api/getaboutusinfo", data)
}

// 业务介绍
export function getWorkInfoListApi(data) {
	return postFormData(baseUrl + "/web_api/getworkinfolist", data)
}

// 业务介绍详情
export function getWorkInfoApi(work_id) {
	return postFormData(baseUrl + "/web_api/getworkinfo", { work_id })
}

// 合作伙伴
export function getCooperativeInfoListApi(data) {
	return postFormData(baseUrl + "/web_api/getcooperativeinfolist", data)
}

// 企业信息
export function getCompanyInfoApi(data) {
	return postFormData(baseUrl + "/web_api/getcompanyinfo", data)
}

// 招聘信息列表
export function getRecruitInfoListApi(data) {
	return postFormData(baseUrl + "/web_api/getrecruitinfolist", data)
}

// 联系我们
export function getContactUsListApi(data) {
	return postFormData(baseUrl + "/web_api/getcontactuslist", data)
}

// 根据字典类型查询字典数据信息
export function getDictDataApi(type) {
	return get(baseUrl + "/web_api/type/" + type)
}

// 通知公告列表
export function getNoticeListApi(data) {
	return get(baseUrl + "/web_api/notice_list", data)
}

// 通知公告详情
export function getNoticeInfoApi(noticeId) {
	return postFormData(baseUrl + "/web_api/check_notice_info", { noticeId })
}

// 获取友情链接
export function getFriendLinkList(data) {
	return get(baseUrl + "/web_api/getFriendLinklist", data)
}

